import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import useCart from '@/public/hooks/use-cart'
import { formattedNumber } from '@/shared/helpers/String'
import { setOpen } from '@/public/redux/cartSlice'
import { customerSignedIn } from '@/shared/helpers/Customer'

export default function CartButton({ userCartId, mobile }) {
  const dispatch = useDispatch()
  const { cart, mutate } = useCart()
  const quantity = cart?.contents?.reduce((sum, item) => sum + item.quantity, 0)
  // A cart the lab company correction emptied still has its notice to show.
  const openable = quantity > 0 || cart?.lab_company_notices?.length > 0

  const handleOpen = (e) => {
    e.stopPropagation()

    if (openable) {
      dispatch(setOpen(true))
    }
  }

  const handleEscape = (e) => {
    if (e.key === 'Escape') {
      dispatch(setOpen(false))
    }
  }

  /**
   * Mount/Unmount
   */
  useEffect(() => {
    document.addEventListener('keydown', handleEscape, false)

    return () => {
      document.removeEventListener('keydown', handleEscape, false)
    }
  }, [])

  useEffect(() => {
    if (userCartId && customerSignedIn) {
      window.localStorage.setItem('cart', userCartId)
      mutate()
    }
  }, [userCartId])

  return (
    <button
      type="button"
      style={{ cursor: openable ? 'pointer' : 'initial' }}
      className={`btn ${mobile ? 'border-0' : 'btn-outline-secondary bg-root-light-blue'} p-2`}
      onClick={(e) => handleOpen(e)}
    >
      <i className={`lh-sm icon-cart ${mobile ? 'text-root-green' : 'text-root-blue'}`} />

      {
        quantity > 0 ? (
          <span className="badge rounded-pill text-root-green me-0">
            {formattedNumber(quantity)}
          </span>
        ) : (
          <span>&nbsp;</span>
        )
      }
    </button>
  )
}
